import { render } from "./DonutChart.vue?vue&type=template&id=20274074&ts=true"
import script from "./DonutChart.vue?vue&type=script&lang=ts"
export * from "./DonutChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__